import { useContext, useEffect, useMemo } from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import FocusLock, { MoveFocusInside } from 'react-focus-lock';
import uuid from 'react-uuid';

import RichText from '../RichText';
import Link from '../Link';
import { Context } from '../../Providers/Blade';

import { Links, Wrapper, NavButton } from './styles';

const link = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
  },
};

const SubMenu = ({ navCtas, navHeader, positionIdx }) => {
  const { state, updateBladeState, resetState } = useContext(Context);

  const sanitizedNavheader = useMemo(
    () => `${uuid()}-${navHeader.replace(/\s+/g, '-').toLowerCase()}`,
    [],
  );

  useEffect(() => {
    const menuBladeState = {};
    menuBladeState[sanitizedNavheader] = false;
    updateBladeState(menuBladeState);
  }, []);

  const handleClick = menuState => {
    const menuBladeState = {};
    menuBladeState[sanitizedNavheader] = menuState;
    updateBladeState(menuBladeState);
  };

  const intl = useIntl();

  return (
    <>
      <NavButton type="button" onClick={() => handleClick(true)}>
        {navHeader}
      </NavButton>
      <Wrapper
        className={state[sanitizedNavheader] ? 'slide-in' : ''}
        $isOpen={state[sanitizedNavheader]}
        $positionIdx={positionIdx}
      >
        <FocusLock disabled={!state[sanitizedNavheader]} returnFocus>
          <Links className="submenu no-bullets" $minItems={navCtas.length + 1}>
            <MoveFocusInside>
              <li>
                <NavButton type="button" onClick={() => handleClick(false)}>
                  {intl.formatMessage({ id: 'back' })}
                </NavButton>
              </li>
              {navCtas.map(cta => {
                return (
                  <li key={cta.id}>
                    <Link
                      className="unstyled-link nav-tab"
                      data={cta}
                      blade
                      resetState={resetState}
                    >
                      <RichText document={cta.label} options={link} />
                    </Link>
                  </li>
                );
              })}
            </MoveFocusInside>
          </Links>
        </FocusLock>
      </Wrapper>
    </>
  );
};

SubMenu.propTypes = {
  navCtas: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  navHeader: PropTypes.string.isRequired,
  positionIdx: PropTypes.number.isRequired,
};

export default SubMenu;
